import { __ } from "services/Translator";
import { useVipData } from "./useCashierData";
import InfoCard from "./InfoCard";
import { VipIcoIcon, PerkCheckIcon } from "./icons";

export default function VipView() {
  const { vip, available, loading } = useVipData();

  // First load not settled: show a skeleton, not the "not available" empty
  // state, so the tier does not flash as missing before /rewards/dashboard
  // resolves.
  if (loading && !vip) {
    return (
      <InfoCard gold>
        <div className="ic-top">
          <span className="ic-ico">
            <VipIcoIcon />
          </span>
          <div className="tt">
            <b className="skel" aria-hidden="true" />
            <small>{__("Loading your VIP level...")}</small>
          </div>
        </div>
        <div className="progress">
          <i style={{ width: "0%" }} />
        </div>
      </InfoCard>
    );
  }

  // Gamification off (endpoint 404s) or no payload yet: honest empty state, no
  // fabricated tier. Gamification is ON for GCC so this is the fallback path.
  if (!available || !vip || !vip.tierName) {
    return (
      <InfoCard>
        <div className="note-line">{__("Your VIP level is not available right now.")}</div>
      </InfoCard>
    );
  }

  const pct = Number.isFinite(Number(vip.progressPct)) ? Number(vip.progressPct) : 0;
  const benefits = Array.isArray(vip.benefits) ? vip.benefits : [];
  const nextBenefits = Array.isArray(vip.nextTierBenefits) ? vip.nextTierBenefits : [];
  const perkText = (b) => (b.value ? b.label + " · " + b.value : b.label);

  return (
    <>
      <InfoCard gold style={{ marginBottom: "16px" }}>
        <div className="ic-top">
          <span className="ic-ico">
            <VipIcoIcon />
          </span>
          <div className="tt">
            <b>{vip.tierName}</b>
            <small>{__("Your current VIP level")}</small>
          </div>
          <span className="amt">{pct}%</span>
        </div>
        <div className="progress">
          <i style={{ width: pct + "%" }} />
        </div>
        <div className="prog-lbl">
          {vip.nextTierName ? (
            <>
              <span>
                {vip.toNextLabel} {__("to")} <b>{vip.nextTierName}</b>
              </span>
              <span>
                {vip.tierName} → {vip.nextTierName}
              </span>
            </>
          ) : (
            <>
              <span>{__("You have reached the highest tier")}</span>
              <span>{vip.tierName}</span>
            </>
          )}
        </div>
      </InfoCard>

      {benefits.length ? (
        <>
          <div className="field-lbl">
            {vip.tierName} {__("perks")}
          </div>
          <div className="perks">
            {benefits.map((b, i) => (
              <div key={i} className="perk">
                <span className="pk">
                  <PerkCheckIcon />
                </span>
                {perkText(b)}
              </div>
            ))}
          </div>
        </>
      ) : null}

      {vip.nextTierName && nextBenefits.length ? (
        <InfoCard style={{ marginTop: "16px" }}>
          <div className="note-line">
            <b>
              {__("Next tier")} · {vip.nextTierName}.
            </b>{" "}
            {__("Unlock")} {nextBenefits.map((b) => perkText(b)).join(", ")}. {__("Keep playing to get there.")}
          </div>
        </InfoCard>
      ) : null}
    </>
  );
}
